import * as React from "react";

import type {AudioCache} from "@khan/guide-core-helpers";

import {GuideAudioProvider} from "./internal/guide-audio-provider.tsx";
import {GuideConversionContextProvider} from "./internal/guide-conversion-context-provider.tsx";
import {GuidePreferencesProvider} from "./internal/guide-preferences-provider.tsx";
import {GuideStateApiProvider} from "./internal/guide-state-api-provider.tsx";
import {MathEditorContextProvider} from "./internal/math-editor-context-provider.tsx";
import {MobileIconMenuContextProvider} from "./internal/mobile-icon-menu-context-provider.tsx";
import {NotificationStateProvider} from "./notification-state-provider.tsx";

interface Props {
    children: React.ReactNode;
    initialAudioCache?: AudioCache;
}

/**
 * Provides the guide context to the application.
 */
const GuideContextProvider = ({
    children,
    initialAudioCache,
}: Props): React.ReactElement => (
    <GuideStateApiProvider>
        <MathEditorContextProvider>
            <MobileIconMenuContextProvider>
                <GuideConversionContextProvider>
                    <GuidePreferencesProvider>
                        <GuideAudioProvider
                            initialAudioCache={initialAudioCache}
                        >
                            <NotificationStateProvider>
                                {children}
                            </NotificationStateProvider>
                        </GuideAudioProvider>
                    </GuidePreferencesProvider>
                </GuideConversionContextProvider>
            </MobileIconMenuContextProvider>
        </MathEditorContextProvider>
    </GuideStateApiProvider>
);

export default GuideContextProvider;
